import IOBoolean from "../widget/io-boolean";
import IODate from "../widget/io-date";
import IOPanelWithNavigation from "../widget/io-panel-with-navigation";
import IOString from "../widget/io-string";
import IOText from "../widget/io-text";
import Panel from "../widget/panel";
import TwoColumns from "../widget/two-columns";
import type { Patient, Surgery } from "./_objects-patient";
import { type RelatedElementGeneratorProps } from "./patient-related-element-generator";

export default function SurgeryElement(
  props: { patient: Patient } & RelatedElementGeneratorProps<Surgery>
): React.ReactNode {
  return (
    <IOPanelWithNavigation<Surgery>
      {...props}
      key={`surgery.${props.file.id}`}
      type="surgery"
      apiRootUrl={`/api/patient/${props.patient.id}/surgery`} // No leading slash!
      restrictedForWrite="write"
      restrictedForUnlock="manage_archives"
      canBeLocked={true}
      basePath={`${props.parentPath}/surgery`}
      header={
        <>
          <span>{props.file.report_diagnostic}</span>
          <span>{props.file.report_surgeon}</span>
        </>
      }
    >
      <TwoColumns>
        <Panel fixed label="Report">
          <input
            type="hidden"
            name="patient_id"
            defaultValue={props.patient.id}
          />
          <IODate name="date" value={props.file.date} required />
          <IOString
            name="report_diagnostic"
            label="Diagnostic"
            value={props.file.report_diagnostic}
          />
          <IOString
            name="report_surgeon"
            label="Surgeon"
            value={props.file.report_surgeon}
          />
          <IOBoolean
            name="report_side_right"
            label="Side Right"
            value={props.file.report_side_right}
          />
          <IOBoolean
            name="report_side_left"
            label="Side Left"
            value={props.file.report_side_left}
          />
          <IOString
            name="report_procedure"
            label="Procedure"
            value={props.file.report_procedure}
          />
        </Panel>
        <Panel fixed label="Hospitalization Follow-up">
          <IOText
            name="follow_up_complication"
            label="Follow-Up Complications"
            value={props.file.follow_up_complication}
          />
        </Panel>
      </TwoColumns>
    </IOPanelWithNavigation>
  );
}
